export default __webpack_public_path__ + "413e55008618a1eb9b16cb7b421b1951.svg";